import { Container } from "@mantine/core";
import Text from "../Text";
import classes from "./index.module.css";
import Image from "next/image";
import Link from "@/components/Link";
import { useTranslation } from "@/i18n/client";
import { ForwardedRef } from "react";

interface FooterProps {
  footerRef?: ForwardedRef<HTMLDivElement>;
}

const Footer = ({ footerRef }: FooterProps) => {
  const { t } = useTranslation("components");

  return (
    <footer ref={footerRef} className={classes.root}>
      <Container size={1400} className={classes.container}>
        <div className={classes.leftSide}>
          <Image src="/images/icons/logo.svg" alt="logo" width={106} height={36} priority />
          <Text variant="reading_small">© E.ON {new Date().getFullYear()}</Text>
        </div>
        <section className={classes.rightSection}>
          <Link href="https://www.eon.cz/pristupnost">
            <Text variant="reading_bold">{t("Footer.accessibility")}</Text>
          </Link>
          <button type="button" className={classes.cookieButton} onClick={() => window.UC_UI.showSecondLayer()}>
            <Text variant="reading_bold">{t("Footer.cookies")}</Text>
          </button>
          <Link href="https://www.eon.cz/">
            <Text variant="reading_bold">{t("Footer.eon")}</Text>
          </Link>
        </section>
      </Container>
    </footer>
  );
};

export default Footer;
